import { createApiCall } from 'lib/base';

const FETCH_MARKET_INDEX_CREATE_API_ID =
  'DASHBOARD/FETCH_MARKET_INDEX_CREATE_API';

const apiCall = createApiCall(
  FETCH_MARKET_INDEX_CREATE_API_ID,
  ({ payload }) => ({
    endpoint: `/api/admin/market-indexes`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
